// src/lib/staff.js
import api, { withBusiness } from "./api";

/**
 * Lista de staff pentru business-ul curent.
 * GET /api/b/staff   (business-ul vine din header X-Business-Id)
 */
export async function listStaff() {
  // fără :businessId în URL, doar X-Business-Id în header
  const url = withBusiness("/b/staff");
  const { data } = await api.get(url);

  if (!Array.isArray(data)) return [];

  return data;
}

/**
 * Update pentru un membru de staff în contextul business-ului curent.
 * PATCH /api/b/staff/<id>
 *
 * Îl folosim pentru a actualiza serviciile
 * pe care le poate presta fiecare membru de staff:
 *   patchStaff(memberId, { services: [1, 2, 3] })
 */
export async function patchStaff(memberId, payload) {
  if (!memberId) {
    throw new Error("patchStaff: memberId is required");
  }

  const url = withBusiness(`/b/staff/${memberId}`);
  const { data } = await api.patch(url, payload);
  return data;
}
